import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { DataProviderInstance } from '../../../../../../api/DataProvider';
import { procedureLabels } from '../../../../../appointments/v2/utils/appointmentUtils';
import { formatBRL, parseDate } from '../wallet-section/walletFormat';
import { paymentState } from './paymentState';
import styles from './PaymentRow.module.css';

const WEEKDAYS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const two = (n) => String(n).padStart(2, '0');

/**
 * Um atendimento na lista de pagamentos: data em bloco, procedimentos e
 * profissional, situação, valor e o atalho para o atendimento. A linha inteira
 * abre o atendimento, onde se fatura, se emite a nota e se vê o pacote usado.
 */
function PaymentRow({ item }) {
  const { CompanyConfig } = DataProviderInstance();
  const navigate = useNavigate();

  const date = parseDate(item.date);
  const weekday = date ? WEEKDAYS[date.getDay()] : '';
  const day = date ? `${two(date.getDate())}/${two(date.getMonth() + 1)}` : '';
  const year = date ? String(date.getFullYear()) : '';
  const time = date ? `${two(date.getHours())}:${two(date.getMinutes())}` : '';

  const procedures = procedureLabels(item, CompanyConfig.Procedures) || 'Sem procedimento';
  const resource = CompanyConfig.Resources.find((r) => String(r.Id) === String(item.resource))?.Label || '';
  const state = paymentState(item);

  const open = () => navigate(`/appointment/${item.id}`);
  const onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      open();
    }
  };

  return (
    <li
      className={styles.row}
      role="link"
      tabIndex={0}
      onClick={open}
      onKeyDown={onKeyDown}
      aria-label={`Abrir atendimento de ${day}/${year} às ${time}`}
    >
      <span className={styles.dateTile} aria-hidden="true">
        <span className={styles.weekday}>{weekday}</span>
        <span className={styles.day}>{day}</span>
        <span className={styles.year}>{year}</span>
      </span>

      <div className={styles.text}>
        <span className={styles.procedures} title={procedures}>{procedures}</span>
        <span className={styles.secondary}>
          <span>{time}</span>
          {resource && <span className={styles.dot}>·</span>}
          {resource && <span>{resource}</span>}
        </span>
      </div>

      <span className={`${styles.state} ${styles[state.tone]}`}>{state.label}</span>
      <span className={styles.price}>{formatBRL(item.price)}</span>
      <ChevronRightRoundedIcon className={styles.chevron} />
    </li>
  );
}

export default PaymentRow;
